import { Observable } from 'rxjs';
import { combineLatestWith, filter, map, startWith, tap } from 'rxjs/operators';

export const trackChangesWhenInactive = <T>(isActiveStream$: Observable<boolean>) => {
  return (source: Observable<T>) => {
    let lastSeenValues: T;

    return source.pipe(
      combineLatestWith(isActiveStream$.pipe(startWith(false))),
      filter(([values, isActive]) => !isActive && lastSeenValues !== values),
      tap(([values]) => (lastSeenValues = values)),
      map(([values]) => values),
    );
  };
};
